import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {PointsData} from "../points.data";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MemberLoyaltyRedemptionTypeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-member-loyalty-redemption-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class MemberLoyaltyRedemptionTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
        this.buildData([
            {label: "wbo.member-loyalty.option.accrual-redemption-type.none", value: PointsData.TYPE_NONE},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perDollar", value: PointsData.TYPE_PER_DOLLAR},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perUnit", value: PointsData.TYPE_PER_UNIT_AT_ANY_PRICE}
        ]);
    }
}
